module.exports = __webpack_public_path__ + "static/media/InternalMedicineImage3.bc147169.png";